import { banners } from "../banners.js";

import { getSchoolsConfig } from "../pl-schoolsConfig.js";
import { getIntegrationConfig } from "../pl-integrationConfig.js";

export const getKatoConfig = () => {
  return {
    cityOptions: {
      isInLocationsPage: false,
      isCityInProgress: false,
      title: "KATOWICE",
      siteUrl: "/kato",
      siteTitle: "Pixel XL Katowice",
      statue: "/documents/katowice/statue.pdf",
      nameKey: "katowice",
      reservationTimeStep: 20,
      isPerformanceReviewEnabled: true,
      street: "sokolska",
    },
    mainSection: {
      isVisible: true,
      isABTestSite: true,
      plan4uApiUrl: "https://xl.plan4u.pl/pixel/katowice/api/v1",
      backgroundImage: "/images/AB/board.jpg",
      youtubeBackgroundVideoID: "uOgvhlGtTMA",
      youtubeMobileBackgroundVideoID: "HxFrAfEqaHM",
    },
    aboutSection: {
      isVisible: true,
      aboutUsImages: [
        "/images/wroclaw/about-us/about-picture-1.jpg",
        "/images/katowice/about-us/about-picture-2.v2.jpg",
        "/images/wroclaw/about-us/about-picture-3.jpg",
        "/images/katowice/about-us/about-picture-4-v2.png",
        "/images/wroclaw/about-us/about-picture-5.jpg",
        "/images/katowice/about-us/about-picture-6-v2.jpg",
      ],
      aboutUsMobileImages: [
        "/images/wroclaw/about-us/mobile-about-picture-1.jpg",
        "/images/katowice/about-us/mobile-about-picture-2.v2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-3.jpg",
        "/images/katowice/about-us/mobile-about-picture-4-v2.png",
        "/images/wroclaw/about-us/mobile-about-picture-5.jpg",
        "/images/katowice/about-us/mobile-about-picture-6-v2.jpg",
      ],
    },
    bookingSection: {
      isVisible: true,
      isBookLinkEnabled: true,
      bookingUrl: {
        eng: "https://xl.plan4u.pl/pixel/katowice/bookItNEW_EN.html",
        de: "https://xl.plan4u.pl/pixel/katowice/bookItNEW_DE.html",
        pl: "https://xl.plan4u.pl/pixel/katowice/bookItNEW_PL.html",
      },
      banners: banners.booking.katowice,
    },
    priceSection: {
      isVisible: true,
      priceBanner: banners.price[35],
    },
    descriptionSection: {
      isVisible: true,
    },
    voucherSection: {
      voucherBanner: banners.voucher,
      isVisible: true,
      voucherPageUrl: "https://xl.plan4u.pl/pixel/katowice/getVoucher.html",
    },
    cooperationSection: {
      isVisible: true,
      isHrefEnabled: true,
      cooperationSectionVisibility: true,
      integrationOfferVisibility: true,
      birthdayOfferVisibility: true,
      schoolOfferVisibility: true,
      schoolPage: getSchoolsConfig().katowice,
      integrationPage: getIntegrationConfig().katowice,
    },
    reviewSection: {
      isVisible: true,
    },
    faqSection: {
      isVisible: true,
    },
    careerSection: {
      isVisible: true,
    },
    contactSection: {
      isVisible: true,
      isMapVisible: true,
      googleMapsOptions: {
        city: "Katowice",
        country: "Poland",
        street: "Sokolska+31",
      },
      address: "Sokolska 31, 40-086 Katowice",
      email: "katowice@pixel-xl.com",
    },
  };
};
